import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Anchor } from "lucide-react";
import { affApi, refStore } from "../lib/affApi";

// seavanto.io/r/SV-XXXX — remembers the code for 90 days, logs the click and
// lands on the normal registration page with the code prefilled.
export default function ReferralRedirect() {
  const { code } = useParams();
  const nav = useNavigate();
  useEffect(() => {
    let alive = true;
    affApi.post("/affiliate/click", { code })
      .then(({ data }) => {
        if (!alive) return;
        if (data.valid) {
          refStore.set(data.code);
          nav(`/register?ref=${encodeURIComponent(data.code)}`, { replace: true });
        } else {
          nav("/register", { replace: true });
        }
      })
      .catch(() => alive && nav("/register", { replace: true }));
    return () => { alive = false; };
  }, [code, nav]);
  return (
    <div className="min-h-screen grid place-items-center bg-white" data-testid="referral-redirect">
      <div className="flex items-center gap-2 text-zinc-500 text-sm">
        <div className="w-7 h-7 rounded-md bg-ink text-white grid place-items-center animate-pulse"><Anchor className="h-4 w-4" /></div>
        Opening Seavanto…
      </div>
    </div>
  );
}
